export default "__VITE_ASSET__D37DqF5p__"